import { render, staticRenderFns } from "./SalePrices.vue?vue&type=template&id=65c7e4d8&"
import script from "./SalePrices.vue?vue&type=script&lang=js&"
export * from "./SalePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports